import { render, staticRenderFns } from "./agenda.vue?vue&type=template&id=257d6c59&scoped=true&"
import script from "./agenda.vue?vue&type=script&lang=js&"
export * from "./agenda.vue?vue&type=script&lang=js&"
import style0 from "./agenda.vue?vue&type=style&index=0&id=257d6c59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d6c59",
  null
  
)

export default component.exports